import React from 'react';
import { motion } from 'framer-motion';
import { trackAddToCart } from './MetaPixel';
export function PricingCTA() {
  return <section id="pricing" className="w-full bg-gradient-to-b from-lime-50 to-lime-100 py-20 lg:py-28" data-id="element-127">
      <div className="max-w-4xl mx-auto px-6 lg:px-12" data-id="element-128">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="text-center space-y-8" data-id="element-129">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900" data-id="element-130">
            Precio
          </h2>

          <div className="bg-white p-12 rounded-2xl shadow-2xl" data-id="element-131">
            <div className="space-y-6" data-id="element-132">
              {/* Discount Badge */}
              <div className="inline-block bg-red-600 text-white px-6 py-2 rounded-full font-bold text-lg" data-id="element-133">
                AHORRA 63% - Oferta Limitada
              </div>

              {/* Pricing */}
              <div className="space-y-4" data-id="element-134">
                <div data-id="element-135">
                  <p className="text-sm text-gray-500 uppercase tracking-wide mb-1" data-id="element-136">
                    Precio original
                  </p>
                  <div className="text-4xl md:text-5xl font-bold text-gray-400 line-through" data-id="element-137">
                    $19.00
                  </div>
                </div>
                <div data-id="element-138">
                  <p className="text-sm text-gray-700 uppercase tracking-wide font-semibold mb-1" data-id="element-139">
                    Precio de oferta
                  </p>
                  <div className="text-6xl md:text-7xl font-bold text-gray-900" data-id="element-140">
                    $6.99
                  </div>
                </div>
              </div>

              <p className="text-xl text-gray-700 font-medium" data-id="element-141">pago único</p>

              <div className="py-6" data-id="element-142">
                <motion.a href="https://www.consejossimples.com/cart/53359207874893:1" onClick={trackAddToCart} whileHover={{
                scale: 1.05
              }} whileTap={{
                scale: 0.95
              }} className="inline-block bg-gray-900 hover:bg-gray-800 text-white font-bold text-xl px-12 py-5 rounded-lg transition-colors duration-200 shadow-lg hover:shadow-xl" data-id="element-143">
                  Consigue Cena Sin Pensar
                </motion.a>
              </div>

              <p className="text-lg text-gray-600 italic max-w-md mx-auto leading-relaxed" data-id="element-144">
                No estás pagando por "comida".
                <br data-id="element-145" />
                Estás pagando por alivio mental.
              </p>
            </div>
          </div>
        </motion.div>

        {/* Final Close */}
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="mt-20 text-center space-y-8" data-id="element-146">
          <h3 className="text-2xl md:text-3xl font-bold text-gray-900" data-id="element-147">
            La verdad simple
          </h3>

          <div className="space-y-6 text-lg leading-relaxed text-gray-700 max-w-2xl mx-auto" data-id="element-148">
            <p data-id="element-149">La cena no es el momento para demostrar disciplina.</p>

            <p className="text-xl font-semibold text-gray-900" data-id="element-150">
              La cena es el momento para cuidarte cuando ya no te queda energía.
            </p>

            <p data-id="element-151">Pega el sistema en tu fridge.</p>

            <p className="text-xl font-bold text-gray-900" data-id="element-152">
              Y deja que esa hoja piense por ti.
            </p>
          </div>

          <motion.a href="https://www.consejossimples.com/cart/53359207874893:1" onClick={trackAddToCart} whileHover={{
          scale: 1.02
        }} whileTap={{
          scale: 0.98
        }} className="inline-block bg-gray-900 hover:bg-gray-800 text-white font-semibold text-lg px-10 py-4 rounded-lg transition-colors duration-200 shadow-md hover:shadow-lg mt-8" data-id="element-153">
            Consigue el Sistema - $6.99
          </motion.a>
        </motion.div>
      </div>
    </section>;
}